import getQueryValueByName from "../utils/getQueryValueByName";
import liveInstance from '../liveController/createLiveInstance'
import request from "../utils/request";
import { useJSBridgeAction } from "@realsee/jsbridge-x/lib/react/hooks";
import { setLiveStateToStore } from "../slices/liveSlice";
import { useDispatch } from "react-redux";
import { isApp } from '../utils/deviceDetect'
import { getSpaceState, setSpaceStateToStore } from '../slices/spaceSlice'

const {
	useConnect,
	useLiveAction
} = liveInstance

function useLiveOperation () {
 	const { exit } = useLiveAction()
	const connect = useConnect()
	const { login, getUserInfo } = useJSBridgeAction()
	const dispatch = useDispatch()
	
	const getUserId = async () => {
		if (isApp) { await login() }
		const [userInfo, error] = await getUserInfo()
		if(!userInfo) {
			throw Error(error?.message || '身份信息获取失败，请重试')
		}
		return userInfo.userId
	}
	
	const liveConnect = async () => {
		const userRole = window.location.search.includes('userRole=audience') ? 'audience' : 'anchor'
		const userId = await getUserId()
		let wsUrl, roomCode
		if (userRole === 'anchor') {
			const [ws_url, room_code] = await getRoomInfo(userId, userRole)
			wsUrl = ws_url
			roomCode = room_code
		}
		else {
			roomCode = getQueryValueByName('roomCode')
			wsUrl = await getWsUrl(roomCode)
		}
		return Promise.resolve().then(() => {
			dispatch(setLiveStateToStore({roomCode: roomCode}))
			connect({
				force: true,
				url: wsUrl,
				getTicket: async  () => {
					return await getTicket({ roomCode, userId, userRole })
				}
			})
		}).catch(error => console.error(error.message))
	}
	
	const liveConnectFromUrl = async (url) => {
 		const userRole = getQueryValueByName('userRole', url)
		const roomCode = getQueryValueByName('roomCode', url)
		const enterLive = getQueryValueByName('enterLive', url)
		if (!enterLive || !roomCode) return
		const userId = await getUserId()
		const wsUrl = await getWsUrl(roomCode)
		return Promise.resolve().then(() => {
			dispatch(setLiveStateToStore({roomCode: roomCode}))
			connect({
				force: true, // 不传此参数有bug，已提阳哥
				url: wsUrl,
				getTicket: async  () => {
					return await getTicket({ roomCode, userId, userRole })
				}
			})
		}).catch(error => console.error(error.message))
	}
	
	// 应该有个callback
	const liveExit = () => {
		return Promise.resolve()
			.then(() => exit())
			.then((res) => {
				if (res) {
					dispatch(setSpaceStateToStore({mode: 'user'}))
					dispatch(setLiveStateToStore({roomCode: ''}))
				}
				else {
					throw Error('退出带看失败')
				}
			})
			.catch(error => {
				console.error(error.message || '退出带看失败')
			})
	}
	
	return {
		liveConnect,
		liveExit,
		liveConnectFromUrl
	}
}

export { useLiveOperation };

// 请求房间信息，包括：ws链接，房间号
export const getRoomInfo = async (userId, userRole) => {
	return request('roomCreate', {
		create_user_role: userRole,
		create_user_id: userId
	}).then((data) => {
		return [data.room_link, data.room_id]
	}).catch((error) => {
		throw Error(error.message || '请求带看房间信息失败')
	})
}

// 查询ws链接
export const getWsUrl = async (roomCode) => {
	return request('getRoomDetail', {
		room_id: roomCode
	})
		.then((data) => {
			return data.room_link
		})
		.catch((error) => {
			throw Error(error.message || '查询带看房间信息失败')
		})
}

// 请求带看门票
const getTicket = async ({roomCode, userId, userRole}) => {
	return request('getTicket', {
		room_id: roomCode,
		user_id: userId,
		user_role: userRole
	})
		.then((data) => {
			return data.ticket
		})
		.catch((error) => {
			throw Error(error.message || '获取带看门票失败')
		})
}
